export default {
  /*
  |--------------------------------------------------------------------------
  | 是否需要接入微信SDK,接入后可配置分享等操作
  |--------------------------------------------------------------------------
  |
  */
  isWechat: true,
  wechatConfig: {
    /*
    |--------------------------------------------------------------------------
    | 获取微信配置的url
    |--------------------------------------------------------------------------
    |
    */
    wechatConfigUrl: '/wechat/jssdk'
  }
}
